import { a as Jt, c as Wr, g as Yt } from "./_commonjsHelpers.B4e78b8K.js";
var Te, Gr;
function be() {
  return Gr || (Gr = 1, Te = TypeError), Te;
}
const Xt = {}, Zt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xt
}, Symbol.toStringTag, { value: "Module" })), en = /* @__PURE__ */ Jt(Zt);
var Be, kr;
function Re() {
  if (kr) return Be;
  kr = 1;
  var o = typeof Map == "function" && Map.prototype, l = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, s = o && l && typeof l.get == "function" ? l.get : null, c = o && Map.prototype.forEach, R = typeof Set == "function" && Set.prototype, E = Object.getOwnPropertyDescriptor && R ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, I = R && E && typeof E.get == "function" ? E.get : null, v = R && Set.prototype.forEach, O = typeof WeakMap == "function" && WeakMap.prototype, p = O ? WeakMap.prototype.has : null, d = typeof WeakSet == "function" && WeakSet.prototype, h = d ? WeakSet.prototype.has : null, F = typeof WeakRef == "function" && WeakRef.prototype, b = F ? WeakRef.prototype.deref : null, n = Boolean.prototype.valueOf, i = Object.prototype.toString, a = Function.prototype.toString, w = String.prototype.match, y = String.prototype.slice, g = String.prototype.replace, M = String.prototype.toUpperCase, P = String.prototype.toLowerCase, S = RegExp.prototype.test, t = Array.prototype.concat, f = Array.prototype.join, m = Array.prototype.slice, A = Math.floor, x = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, q = Object.getOwnPropertySymbols, T = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, N = typeof Symbol == "function" && typeof Symbol.iterator == "object", G = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === N || !0) ? Symbol.toStringTag : null, D = Object.prototype.propertyIsEnumerable, B = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
    return e.__proto__;
  } : null);
  function u(e, r) {
    if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || S.call(/e/, r))
      return r;
    var C = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof e == "number") {
      var U = e < 0 ? -A(-e) : A(e);
      if (U !== e) {
        var W = String(U), _ = y.call(r, W.length + 1);
        return g.call(W, C, "$&_") + "." + g.call(g.call(_, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return g.call(r, C, "$&_");
  }
  var V = en, te = V.custom, ye = K(te) ? te : null, ae = {
    __proto__: null,
    double: '"',
    single: "'"
  }, oe = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  Be = function e(r, C, U, W) {
    var _ = C || {};
    if (j(_, "quoteStyle") && !j(ae, _.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (j(_, "maxStringLength") && (typeof _.maxStringLength == "number" ? _.maxStringLength < 0 && _.maxStringLength !== 1 / 0 : _.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var ce = j(_, "customInspect") ? _.customInspect : !0;
    if (typeof ce != "boolean" && ce !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (j(_, "indent") && _.indent !== null && _.indent !== "	" && !(parseInt(_.indent, 10) === _.indent && _.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (j(_, "numericSeparator") && typeof _.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var se = _.numericSeparator;
    if (typeof r > "u")
      return "undefined";
    if (r === null)
      return "null";
    if (typeof r == "boolean")
      return r ? "true" : "false";
    if (typeof r == "string")
      return Fr(r, _);
    if (typeof r == "number") {
      if (r === 0)
        return 1 / 0 / r > 0 ? "0" : "-0";
      var J = String(r);
      return se ? u(r, J) : J;
    }
    if (typeof r == "bigint") {
      var pe = String(r) + "n";
      return se ? u(r, pe) : pe;
    }
    var _e = typeof _.depth > "u" ? 5 : _.depth;
    if (typeof U > "u" && (U = 0), U >= _e && _e > 0 && typeof r == "object")
      return fe(r) ? "[Array]" : "[Object]";
    var ge = Qt(_, U);
    if (typeof W > "u")
      W = [];
    else if (le(W, r) >= 0)
      return "[Circular]";
    function re(Se, Pe, jt) {
      if (Pe && (W = m.call(W), W.push(Pe)), jt) {
        var Ur = {
          depth: _.depth
        };
        return j(_, "quoteStyle") && (Ur.quoteStyle = _.quoteStyle), e(Se, Ur, U + 1, W);
      }
      return e(Se, _, U + 1, W);
    }
    if (typeof r == "function" && !z(r)) {
      var Mr = de(r), $r = Oe(r, re);
      return "[Function" + (Mr ? ": " + Mr : " (anonymous)") + "]" + ($r.length > 0 ? " { " + f.call($r, ", ") + " }" : "");
    }
    if (K(r)) {
      var Nr = N ? g.call(String(r), /^(Symbol\(.*\))_[^)]*$/, "$1") : T.call(r);
      return typeof r == "object" && !N ? we(Nr) : Nr;
    }
    if (Ht(r)) {
      for (var Ae = "<" + P.call(String(r.nodeName)), Fe = r.attributes || [], Ee = 0; Ee < Fe.length; Ee++)
        Ae += " " + Fe[Ee].name + "=" + ie(ne(Fe[Ee].value), "double", _);
      return Ae += ">", r.childNodes && r.childNodes.length && (Ae += "..."), Ae += "</" + P.call(String(r.nodeName)) + ">", Ae;
    }
    if (fe(r)) {
      if (r.length === 0)
        return "[]";
      var De = Oe(r, re);
      return ge && !Kt(De) ? "[" + qe(De, ge) + "]" : "[ " + f.call(De, ", ") + " ]";
    }
    if ($(r)) {
      var Me = Oe(r, re);
      return !("cause" in Error.prototype) && "cause" in r && !D.call(r, "cause") ? "{ [" + String(r) + "] " + f.call(t.call("[cause]: " + re(r.cause), Me), ", ") + " }" : Me.length === 0 ? "[" + String(r) + "]" : "{ [" + String(r) + "] " + f.call(Me, ", ") + " }";
    }
    if (typeof r == "object" && ce) {
      if (ye && typeof r[ye] == "function" && V)
        return V(r, { depth: _e - U });
      if (ce !== "symbol" && typeof r.inspect == "function")
        return r.inspect();
    }
    if (ee(r)) {
      var Cr = [];
      return c && c.call(r, function(Se, Pe) {
        Cr.push(re(Pe, r, !0) + " => " + re(Se, r));
      }), Dr("Map", s.call(r), Cr, ge);
    }
    if (me(r)) {
      var Tr = [];
      return v && v.call(r, function(Se) {
        Tr.push(re(Se, r));
      }), Dr("Set", I.call(r), Tr, ge);
    }
    if (ve(r))
      return Ie("WeakMap");
    if (kt(r))
      return Ie("WeakSet");
    if (he(r))
      return Ie("WeakRef");
    if (L(r))
      return we(re(Number(r)));
    if (X(r))
      return we(re(x.call(r)));
    if (H(r))
      return we(n.call(r));
    if (k(r))
      return we(re(String(r)));
    if (typeof window < "u" && r === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && r === globalThis || typeof Wr < "u" && r === Wr)
      return "{ [object globalThis] }";
    if (!ue(r) && !z(r)) {
      var $e = Oe(r, re), Br = B ? B(r) === Object.prototype : r instanceof Object || r.constructor === Object, Ne = r instanceof Object ? "" : "null prototype", Lr = !Br && G && Object(r) === r && G in r ? y.call(Z(r), 8, -1) : Ne ? "Object" : "", Vt = Br || typeof r.constructor != "function" ? "" : r.constructor.name ? r.constructor.name + " " : "", Ce = Vt + (Lr || Ne ? "[" + f.call(t.call([], Lr || [], Ne || []), ": ") + "] " : "");
      return $e.length === 0 ? Ce + "{}" : ge ? Ce + "{" + qe($e, ge) + "}" : Ce + "{ " + f.call($e, ", ") + " }";
    }
    return String(r);
  };
  function ie(e, r, C) {
    var U = C.quoteStyle || r, W = ae[U];
    return W + e + W;
  }
  function ne(e) {
    return g.call(String(e), /"/g, "&quot;");
  }
  function Y(e) {
    return !G || !(typeof e == "object" && (G in e || typeof e[G] < "u"));
  }
  function fe(e) {
    return Z(e) === "[object Array]" && Y(e);
  }
  function ue(e) {
    return Z(e) === "[object Date]" && Y(e);
  }
  function z(e) {
    return Z(e) === "[object RegExp]" && Y(e);
  }
  function $(e) {
    return Z(e) === "[object Error]" && Y(e);
  }
  function k(e) {
    return Z(e) === "[object String]" && Y(e);
  }
  function L(e) {
    return Z(e) === "[object Number]" && Y(e);
  }
  function H(e) {
    return Z(e) === "[object Boolean]" && Y(e);
  }
  function K(e) {
    if (N)
      return e && typeof e == "object" && e instanceof Symbol;
    if (typeof e == "symbol")
      return !0;
    if (!e || typeof e != "object" || !T)
      return !1;
    try {
      return T.call(e), !0;
    } catch {
    }
    return !1;
  }
  function X(e) {
    if (!e || typeof e != "object" || !x)
      return !1;
    try {
      return x.call(e), !0;
    } catch {
    }
    return !1;
  }
  var Q = Object.prototype.hasOwnProperty || function(e) {
    return e in this;
  };
  function j(e, r) {
    return Q.call(e, r);
  }
  function Z(e) {
    return i.call(e);
  }
  function de(e) {
    if (e.name)
      return e.name;
    var r = w.call(a.call(e), /^function\s*([\w$]+)/);
    return r ? r[1] : null;
  }
  function le(e, r) {
    if (e.indexOf)
      return e.indexOf(r);
    for (var C = 0, U = e.length; C < U; C++)
      if (e[C] === r)
        return C;
    return -1;
  }
  function ee(e) {
    if (!s || !e || typeof e != "object")
      return !1;
    try {
      s.call(e);
      try {
        I.call(e);
      } catch {
        return !0;
      }
      return e instanceof Map;
    } catch {
    }
    return !1;
  }
  function ve(e) {
    if (!p || !e || typeof e != "object")
      return !1;
    try {
      p.call(e, p);
      try {
        h.call(e, h);
      } catch {
        return !0;
      }
      return e instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function he(e) {
    if (!b || !e || typeof e != "object")
      return !1;
    try {
      return b.call(e), !0;
    } catch {
    }
    return !1;
  }
  function me(e) {
    if (!I || !e || typeof e != "object")
      return !1;
    try {
      I.call(e);
      try {
        s.call(e);
      } catch {
        return !0;
      }
      return e instanceof Set;
    } catch {
    }
    return !1;
  }
  function kt(e) {
    if (!h || !e || typeof e != "object")
      return !1;
    try {
      h.call(e, h);
      try {
        p.call(e, p);
      } catch {
        return !0;
      }
      return e instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Ht(e) {
    return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
  }
  function Fr(e, r) {
    if (e.length > r.maxStringLength) {
      var C = e.length - r.maxStringLength, U = "... " + C + " more character" + (C > 1 ? "s" : "");
      return Fr(y.call(e, 0, r.maxStringLength), r) + U;
    }
    var W = oe[r.quoteStyle || "single"];
    W.lastIndex = 0;
    var _ = g.call(g.call(e, W, "\\$1"), /[\x00-\x1f]/g, zt);
    return ie(_, "single", r);
  }
  function zt(e) {
    var r = e.charCodeAt(0), C = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[r];
    return C ? "\\" + C : "\\x" + (r < 16 ? "0" : "") + M.call(r.toString(16));
  }
  function we(e) {
    return "Object(" + e + ")";
  }
  function Ie(e) {
    return e + " { ? }";
  }
  function Dr(e, r, C, U) {
    var W = U ? qe(C, U) : f.call(C, ", ");
    return e + " (" + r + ") {" + W + "}";
  }
  function Kt(e) {
    for (var r = 0; r < e.length; r++)
      if (le(e[r], `
`) >= 0)
        return !1;
    return !0;
  }
  function Qt(e, r) {
    var C;
    if (e.indent === "	")
      C = "	";
    else if (typeof e.indent == "number" && e.indent > 0)
      C = f.call(Array(e.indent + 1), " ");
    else
      return null;
    return {
      base: C,
      prev: f.call(Array(r + 1), C)
    };
  }
  function qe(e, r) {
    if (e.length === 0)
      return "";
    var C = `
` + r.prev + r.base;
    return C + f.call(e, "," + C) + `
` + r.prev;
  }
  function Oe(e, r) {
    var C = fe(e), U = [];
    if (C) {
      U.length = e.length;
      for (var W = 0; W < e.length; W++)
        U[W] = j(e, W) ? r(e[W], e) : "";
    }
    var _ = typeof q == "function" ? q(e) : [], ce;
    if (N) {
      ce = {};
      for (var se = 0; se < _.length; se++)
        ce["$" + _[se]] = _[se];
    }
    for (var J in e)
      j(e, J) && (C && String(Number(J)) === J && J < e.length || N && ce["$" + J] instanceof Symbol || (S.call(/[^\w$]/, J) ? U.push(r(J, e) + ": " + r(e[J], e)) : U.push(J + ": " + r(e[J], e))));
    if (typeof q == "function")
      for (var pe = 0; pe < _.length; pe++)
        D.call(e, _[pe]) && U.push("[" + r(_[pe]) + "]: " + r(e[_[pe]], e));
    return U;
  }
  return Be;
}
var Le, Hr;
function rn() {
  if (Hr) return Le;
  Hr = 1;
  var o = /* @__PURE__ */ Re(), l = /* @__PURE__ */ be(), s = function(v, O, p) {
    for (var d = v, h; (h = d.next) != null; d = h)
      if (h.key === O)
        return d.next = h.next, p || (h.next = /** @type {NonNullable<typeof list.next>} */
        v.next, v.next = h), h;
  }, c = function(v, O) {
    if (v) {
      var p = s(v, O);
      return p && p.value;
    }
  }, R = function(v, O, p) {
    var d = s(v, O);
    d ? d.value = p : v.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: O,
      next: v.next,
      value: p
    };
  }, E = function(v, O) {
    return v ? !!s(v, O) : !1;
  }, I = function(v, O) {
    if (v)
      return s(v, O, !0);
  };
  return Le = function() {
    var O, p = {
      assert: function(d) {
        if (!p.has(d))
          throw new l("Side channel does not contain " + o(d));
      },
      delete: function(d) {
        var h = O && O.next, F = I(O, d);
        return F && h && h === F && (O = void 0), !!F;
      },
      get: function(d) {
        return c(O, d);
      },
      has: function(d) {
        return E(O, d);
      },
      set: function(d, h) {
        O || (O = {
          next: void 0
        }), R(
          /** @type {NonNullable<typeof $o>} */
          O,
          d,
          h
        );
      }
    };
    return p;
  }, Le;
}
var Ue, zr;
function Mt() {
  return zr || (zr = 1, Ue = Object), Ue;
}
var We, Kr;
function tn() {
  return Kr || (Kr = 1, We = Error), We;
}
var Ge, Qr;
function nn() {
  return Qr || (Qr = 1, Ge = EvalError), Ge;
}
var ke, Vr;
function an() {
  return Vr || (Vr = 1, ke = RangeError), ke;
}
var He, jr;
function on() {
  return jr || (jr = 1, He = ReferenceError), He;
}
var ze, Jr;
function fn() {
  return Jr || (Jr = 1, ze = SyntaxError), ze;
}
var Ke, Yr;
function un() {
  return Yr || (Yr = 1, Ke = URIError), Ke;
}
var Qe, Xr;
function ln() {
  return Xr || (Xr = 1, Qe = Math.abs), Qe;
}
var Ve, Zr;
function cn() {
  return Zr || (Zr = 1, Ve = Math.floor), Ve;
}
var je, et;
function pn() {
  return et || (et = 1, je = Math.max), je;
}
var Je, rt;
function yn() {
  return rt || (rt = 1, Je = Math.min), Je;
}
var Ye, tt;
function sn() {
  return tt || (tt = 1, Ye = Math.pow), Ye;
}
var Xe, nt;
function dn() {
  return nt || (nt = 1, Xe = Math.round), Xe;
}
var Ze, at;
function vn() {
  return at || (at = 1, Ze = Number.isNaN || function(l) {
    return l !== l;
  }), Ze;
}
var er, ot;
function hn() {
  if (ot) return er;
  ot = 1;
  var o = /* @__PURE__ */ vn();
  return er = function(s) {
    return o(s) || s === 0 ? s : s < 0 ? -1 : 1;
  }, er;
}
var rr, it;
function mn() {
  return it || (it = 1, rr = Object.getOwnPropertyDescriptor), rr;
}
var tr, ft;
function $t() {
  if (ft) return tr;
  ft = 1;
  var o = /* @__PURE__ */ mn();
  if (o)
    try {
      o([], "length");
    } catch {
      o = null;
    }
  return tr = o, tr;
}
var nr, ut;
function gn() {
  if (ut) return nr;
  ut = 1;
  var o = Object.defineProperty || !1;
  if (o)
    try {
      o({}, "a", { value: 1 });
    } catch {
      o = !1;
    }
  return nr = o, nr;
}
var ar, lt;
function Sn() {
  return lt || (lt = 1, ar = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var l = {}, s = Symbol("test"), c = Object(s);
    if (typeof s == "string" || Object.prototype.toString.call(s) !== "[object Symbol]" || Object.prototype.toString.call(c) !== "[object Symbol]")
      return !1;
    var R = 42;
    l[s] = R;
    for (var E in l)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(l).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(l).length !== 0)
      return !1;
    var I = Object.getOwnPropertySymbols(l);
    if (I.length !== 1 || I[0] !== s || !Object.prototype.propertyIsEnumerable.call(l, s))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var v = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(l, s)
      );
      if (v.value !== R || v.enumerable !== !0)
        return !1;
    }
    return !0;
  }), ar;
}
var or, ct;
function bn() {
  if (ct) return or;
  ct = 1;
  var o = typeof Symbol < "u" && Symbol, l = Sn();
  return or = function() {
    return typeof o != "function" || typeof Symbol != "function" || typeof o("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : l();
  }, or;
}
var ir, pt;
function Nt() {
  return pt || (pt = 1, ir = typeof Reflect < "u" && Reflect.getPrototypeOf || null), ir;
}
var fr, yt;
function Ct() {
  if (yt) return fr;
  yt = 1;
  var o = /* @__PURE__ */ Mt();
  return fr = o.getPrototypeOf || null, fr;
}
var ur, st;
function wn() {
  if (st) return ur;
  st = 1;
  var o = "Function.prototype.bind called on incompatible ", l = Object.prototype.toString, s = Math.max, c = "[object Function]", R = function(O, p) {
    for (var d = [], h = 0; h < O.length; h += 1)
      d[h] = O[h];
    for (var F = 0; F < p.length; F += 1)
      d[F + O.length] = p[F];
    return d;
  }, E = function(O, p) {
    for (var d = [], h = p, F = 0; h < O.length; h += 1, F += 1)
      d[F] = O[h];
    return d;
  }, I = function(v, O) {
    for (var p = "", d = 0; d < v.length; d += 1)
      p += v[d], d + 1 < v.length && (p += O);
    return p;
  };
  return ur = function(O) {
    var p = this;
    if (typeof p != "function" || l.apply(p) !== c)
      throw new TypeError(o + p);
    for (var d = E(arguments, 1), h, F = function() {
      if (this instanceof h) {
        var w = p.apply(
          this,
          R(d, arguments)
        );
        return Object(w) === w ? w : this;
      }
      return p.apply(
        O,
        R(d, arguments)
      );
    }, b = s(0, p.length - d.length), n = [], i = 0; i < b; i++)
      n[i] = "$" + i;
    if (h = Function("binder", "return function (" + I(n, ",") + "){ return binder.apply(this,arguments); }")(F), p.prototype) {
      var a = function() {
      };
      a.prototype = p.prototype, h.prototype = new a(), a.prototype = null;
    }
    return h;
  }, ur;
}
var lr, dt;
function xe() {
  if (dt) return lr;
  dt = 1;
  var o = wn();
  return lr = Function.prototype.bind || o, lr;
}
var cr, vt;
function Ir() {
  return vt || (vt = 1, cr = Function.prototype.call), cr;
}
var pr, ht;
function Tt() {
  return ht || (ht = 1, pr = Function.prototype.apply), pr;
}
var yr, mt;
function An() {
  return mt || (mt = 1, yr = typeof Reflect < "u" && Reflect && Reflect.apply), yr;
}
var sr, gt;
function On() {
  if (gt) return sr;
  gt = 1;
  var o = xe(), l = Tt(), s = Ir(), c = An();
  return sr = c || o.call(s, l), sr;
}
var dr, St;
function Bt() {
  if (St) return dr;
  St = 1;
  var o = xe(), l = /* @__PURE__ */ be(), s = Ir(), c = On();
  return dr = function(E) {
    if (E.length < 1 || typeof E[0] != "function")
      throw new l("a function is required");
    return c(o, s, E);
  }, dr;
}
var vr, bt;
function En() {
  if (bt) return vr;
  bt = 1;
  var o = Bt(), l = /* @__PURE__ */ $t(), s;
  try {
    s = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (I) {
    if (!I || typeof I != "object" || !("code" in I) || I.code !== "ERR_PROTO_ACCESS")
      throw I;
  }
  var c = !!s && l && l(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), R = Object, E = R.getPrototypeOf;
  return vr = c && typeof c.get == "function" ? o([c.get]) : typeof E == "function" ? (
    /** @type {import('./get')} */
    function(v) {
      return E(v == null ? v : R(v));
    }
  ) : !1, vr;
}
var hr, wt;
function Pn() {
  if (wt) return hr;
  wt = 1;
  var o = Nt(), l = Ct(), s = /* @__PURE__ */ En();
  return hr = o ? function(R) {
    return o(R);
  } : l ? function(R) {
    if (!R || typeof R != "object" && typeof R != "function")
      throw new TypeError("getProto: not an object");
    return l(R);
  } : s ? function(R) {
    return s(R);
  } : null, hr;
}
var mr, At;
function Rn() {
  if (At) return mr;
  At = 1;
  var o = Function.prototype.call, l = Object.prototype.hasOwnProperty, s = xe();
  return mr = s.call(o, l), mr;
}
var gr, Ot;
function qr() {
  if (Ot) return gr;
  Ot = 1;
  var o, l = /* @__PURE__ */ Mt(), s = /* @__PURE__ */ tn(), c = /* @__PURE__ */ nn(), R = /* @__PURE__ */ an(), E = /* @__PURE__ */ on(), I = /* @__PURE__ */ fn(), v = /* @__PURE__ */ be(), O = /* @__PURE__ */ un(), p = /* @__PURE__ */ ln(), d = /* @__PURE__ */ cn(), h = /* @__PURE__ */ pn(), F = /* @__PURE__ */ yn(), b = /* @__PURE__ */ sn(), n = /* @__PURE__ */ dn(), i = /* @__PURE__ */ hn(), a = Function, w = function(z) {
    try {
      return a('"use strict"; return (' + z + ").constructor;")();
    } catch {
    }
  }, y = /* @__PURE__ */ $t(), g = /* @__PURE__ */ gn(), M = function() {
    throw new v();
  }, P = y ? function() {
    try {
      return arguments.callee, M;
    } catch {
      try {
        return y(arguments, "callee").get;
      } catch {
        return M;
      }
    }
  }() : M, S = bn()(), t = Pn(), f = Ct(), m = Nt(), A = Tt(), x = Ir(), q = {}, T = typeof Uint8Array > "u" || !t ? o : t(Uint8Array), N = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? o : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? o : ArrayBuffer,
    "%ArrayIteratorPrototype%": S && t ? t([][Symbol.iterator]()) : o,
    "%AsyncFromSyncIteratorPrototype%": o,
    "%AsyncFunction%": q,
    "%AsyncGenerator%": q,
    "%AsyncGeneratorFunction%": q,
    "%AsyncIteratorPrototype%": q,
    "%Atomics%": typeof Atomics > "u" ? o : Atomics,
    "%BigInt%": typeof BigInt > "u" ? o : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? o : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? o : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? o : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": s,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": c,
    "%Float16Array%": typeof Float16Array > "u" ? o : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? o : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? o : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? o : FinalizationRegistry,
    "%Function%": a,
    "%GeneratorFunction%": q,
    "%Int8Array%": typeof Int8Array > "u" ? o : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? o : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? o : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": S && t ? t(t([][Symbol.iterator]())) : o,
    "%JSON%": typeof JSON == "object" ? JSON : o,
    "%Map%": typeof Map > "u" ? o : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !S || !t ? o : t((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": l,
    "%Object.getOwnPropertyDescriptor%": y,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? o : Promise,
    "%Proxy%": typeof Proxy > "u" ? o : Proxy,
    "%RangeError%": R,
    "%ReferenceError%": E,
    "%Reflect%": typeof Reflect > "u" ? o : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? o : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !S || !t ? o : t((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? o : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": S && t ? t(""[Symbol.iterator]()) : o,
    "%Symbol%": S ? Symbol : o,
    "%SyntaxError%": I,
    "%ThrowTypeError%": P,
    "%TypedArray%": T,
    "%TypeError%": v,
    "%Uint8Array%": typeof Uint8Array > "u" ? o : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? o : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? o : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? o : Uint32Array,
    "%URIError%": O,
    "%WeakMap%": typeof WeakMap > "u" ? o : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? o : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? o : WeakSet,
    "%Function.prototype.call%": x,
    "%Function.prototype.apply%": A,
    "%Object.defineProperty%": g,
    "%Object.getPrototypeOf%": f,
    "%Math.abs%": p,
    "%Math.floor%": d,
    "%Math.max%": h,
    "%Math.min%": F,
    "%Math.pow%": b,
    "%Math.round%": n,
    "%Math.sign%": i,
    "%Reflect.getPrototypeOf%": m
  };
  if (t)
    try {
      null.error;
    } catch (z) {
      var G = t(t(z));
      N["%Error.prototype%"] = G;
    }
  var D = function z($) {
    var k;
    if ($ === "%AsyncFunction%")
      k = w("async function () {}");
    else if ($ === "%GeneratorFunction%")
      k = w("function* () {}");
    else if ($ === "%AsyncGeneratorFunction%")
      k = w("async function* () {}");
    else if ($ === "%AsyncGenerator%") {
      var L = z("%AsyncGeneratorFunction%");
      L && (k = L.prototype);
    } else if ($ === "%AsyncIteratorPrototype%") {
      var H = z("%AsyncGenerator%");
      H && t && (k = t(H.prototype));
    }
    return N[$] = k, k;
  }, B = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, u = xe(), V = /* @__PURE__ */ Rn(), te = u.call(x, Array.prototype.concat), ye = u.call(A, Array.prototype.splice), ae = u.call(x, String.prototype.replace), oe = u.call(x, String.prototype.slice), ie = u.call(x, RegExp.prototype.exec), ne = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Y = /\\(\\)?/g, fe = function($) {
    var k = oe($, 0, 1), L = oe($, -1);
    if (k === "%" && L !== "%")
      throw new I("invalid intrinsic syntax, expected closing `%`");
    if (L === "%" && k !== "%")
      throw new I("invalid intrinsic syntax, expected opening `%`");
    var H = [];
    return ae($, ne, function(K, X, Q, j) {
      H[H.length] = Q ? ae(j, Y, "$1") : X || K;
    }), H;
  }, ue = function($, k) {
    var L = $, H;
    if (V(B, L) && (H = B[L], L = "%" + H[0] + "%"), V(N, L)) {
      var K = N[L];
      if (K === q && (K = D(L)), typeof K > "u" && !k)
        throw new v("intrinsic " + $ + " exists, but is not available. Please file an issue!");
      return {
        alias: H,
        name: L,
        value: K
      };
    }
    throw new I("intrinsic " + $ + " does not exist!");
  };
  return gr = function($, k) {
    if (typeof $ != "string" || $.length === 0)
      throw new v("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof k != "boolean")
      throw new v('"allowMissing" argument must be a boolean');
    if (ie(/^%?[^%]*%?$/, $) === null)
      throw new I("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var L = fe($), H = L.length > 0 ? L[0] : "", K = ue("%" + H + "%", k), X = K.name, Q = K.value, j = !1, Z = K.alias;
    Z && (H = Z[0], ye(L, te([0, 1], Z)));
    for (var de = 1, le = !0; de < L.length; de += 1) {
      var ee = L[de], ve = oe(ee, 0, 1), he = oe(ee, -1);
      if ((ve === '"' || ve === "'" || ve === "`" || he === '"' || he === "'" || he === "`") && ve !== he)
        throw new I("property names with quotes must have matching quotes");
      if ((ee === "constructor" || !le) && (j = !0), H += "." + ee, X = "%" + H + "%", V(N, X))
        Q = N[X];
      else if (Q != null) {
        if (!(ee in Q)) {
          if (!k)
            throw new v("base intrinsic for " + $ + " exists, but the property is not available.");
          return;
        }
        if (y && de + 1 >= L.length) {
          var me = y(Q, ee);
          le = !!me, le && "get" in me && !("originalValue" in me.get) ? Q = me.get : Q = Q[ee];
        } else
          le = V(Q, ee), Q = Q[ee];
        le && !j && (N[X] = Q);
      }
    }
    return Q;
  }, gr;
}
var Sr, Et;
function Lt() {
  if (Et) return Sr;
  Et = 1;
  var o = /* @__PURE__ */ qr(), l = Bt(), s = l([o("%String.prototype.indexOf%")]);
  return Sr = function(R, E) {
    var I = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      o(R, !!E)
    );
    return typeof I == "function" && s(R, ".prototype.") > -1 ? l(
      /** @type {const} */
      [I]
    ) : I;
  }, Sr;
}
var br, Pt;
function Ut() {
  if (Pt) return br;
  Pt = 1;
  var o = /* @__PURE__ */ qr(), l = /* @__PURE__ */ Lt(), s = /* @__PURE__ */ Re(), c = /* @__PURE__ */ be(), R = o("%Map%", !0), E = l("Map.prototype.get", !0), I = l("Map.prototype.set", !0), v = l("Map.prototype.has", !0), O = l("Map.prototype.delete", !0), p = l("Map.prototype.size", !0);
  return br = !!R && /** @type {Exclude<import('.'), false>} */
  function() {
    var h, F = {
      assert: function(b) {
        if (!F.has(b))
          throw new c("Side channel does not contain " + s(b));
      },
      delete: function(b) {
        if (h) {
          var n = O(h, b);
          return p(h) === 0 && (h = void 0), n;
        }
        return !1;
      },
      get: function(b) {
        if (h)
          return E(h, b);
      },
      has: function(b) {
        return h ? v(h, b) : !1;
      },
      set: function(b, n) {
        h || (h = new R()), I(h, b, n);
      }
    };
    return F;
  }, br;
}
var wr, Rt;
function xn() {
  if (Rt) return wr;
  Rt = 1;
  var o = /* @__PURE__ */ qr(), l = /* @__PURE__ */ Lt(), s = /* @__PURE__ */ Re(), c = Ut(), R = /* @__PURE__ */ be(), E = o("%WeakMap%", !0), I = l("WeakMap.prototype.get", !0), v = l("WeakMap.prototype.set", !0), O = l("WeakMap.prototype.has", !0), p = l("WeakMap.prototype.delete", !0);
  return wr = E ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var h, F, b = {
        assert: function(n) {
          if (!b.has(n))
            throw new R("Side channel does not contain " + s(n));
        },
        delete: function(n) {
          if (E && n && (typeof n == "object" || typeof n == "function")) {
            if (h)
              return p(h, n);
          } else if (c && F)
            return F.delete(n);
          return !1;
        },
        get: function(n) {
          return E && n && (typeof n == "object" || typeof n == "function") && h ? I(h, n) : F && F.get(n);
        },
        has: function(n) {
          return E && n && (typeof n == "object" || typeof n == "function") && h ? O(h, n) : !!F && F.has(n);
        },
        set: function(n, i) {
          E && n && (typeof n == "object" || typeof n == "function") ? (h || (h = new E()), v(h, n, i)) : c && (F || (F = c()), F.set(n, i));
        }
      };
      return b;
    }
  ) : c, wr;
}
var Ar, xt;
function Wt() {
  if (xt) return Ar;
  xt = 1;
  var o = /* @__PURE__ */ be(), l = /* @__PURE__ */ Re(), s = rn(), c = Ut(), R = xn(), E = R || c || s;
  return Ar = function() {
    var v, O = {
      assert: function(p) {
        if (!O.has(p))
          throw new o("Side channel does not contain " + l(p));
      },
      delete: function(p) {
        return !!v && v.delete(p);
      },
      get: function(p) {
        return v && v.get(p);
      },
      has: function(p) {
        return !!v && v.has(p);
      },
      set: function(p, d) {
        v || (v = E()), v.set(p, d);
      }
    };
    return O;
  }, Ar;
}
var Or, It;
function _r() {
  if (It) return Or;
  It = 1;
  var o = String.prototype.replace, l = /%20/g, s = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Or = {
    default: s.RFC3986,
    formatters: {
      RFC1738: function(c) {
        return o.call(c, l, "+");
      },
      RFC3986: function(c) {
        return String(c);
      }
    },
    RFC1738: s.RFC1738,
    RFC3986: s.RFC3986
  }, Or;
}
var Er, qt;
function Gt() {
  if (qt) return Er;
  qt = 1;
  var o = /* @__PURE__ */ _r(), l = Wt(), s = Object.prototype.hasOwnProperty, c = Array.isArray, R = l(), E = function(t, f) {
    return R.set(t, f), t;
  }, I = function(t) {
    return R.has(t);
  }, v = function(t) {
    return R.get(t);
  }, O = function(t, f) {
    R.set(t, f);
  }, p = function() {
    for (var S = [], t = 0; t < 256; ++t)
      S.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
    return S;
  }(), d = function(t) {
    for (; t.length > 1; ) {
      var f = t.pop(), m = f.obj[f.prop];
      if (c(m)) {
        for (var A = [], x = 0; x < m.length; ++x)
          typeof m[x] < "u" && A.push(m[x]);
        f.obj[f.prop] = A;
      }
    }
  }, h = function(t, f) {
    for (var m = f && f.plainObjects ? { __proto__: null } : {}, A = 0; A < t.length; ++A)
      typeof t[A] < "u" && (m[A] = t[A]);
    return m;
  }, F = function S(t, f, m) {
    if (!f)
      return t;
    if (typeof f != "object" && typeof f != "function") {
      if (c(t))
        t.push(f);
      else if (t && typeof t == "object")
        if (I(t)) {
          var A = v(t) + 1;
          t[A] = f, O(t, A);
        } else (m && (m.plainObjects || m.allowPrototypes) || !s.call(Object.prototype, f)) && (t[f] = !0);
      else
        return [t, f];
      return t;
    }
    if (!t || typeof t != "object") {
      if (I(f)) {
        for (var x = Object.keys(f), q = m && m.plainObjects ? { __proto__: null, 0: t } : { 0: t }, T = 0; T < x.length; T++) {
          var N = parseInt(x[T], 10);
          q[N + 1] = f[x[T]];
        }
        return E(q, v(f) + 1);
      }
      return [t].concat(f);
    }
    var G = t;
    return c(t) && !c(f) && (G = h(t, m)), c(t) && c(f) ? (f.forEach(function(D, B) {
      if (s.call(t, B)) {
        var u = t[B];
        u && typeof u == "object" && D && typeof D == "object" ? t[B] = S(u, D, m) : t.push(D);
      } else
        t[B] = D;
    }), t) : Object.keys(f).reduce(function(D, B) {
      var u = f[B];
      return s.call(D, B) ? D[B] = S(D[B], u, m) : D[B] = u, D;
    }, G);
  }, b = function(t, f) {
    return Object.keys(f).reduce(function(m, A) {
      return m[A] = f[A], m;
    }, t);
  }, n = function(S, t, f) {
    var m = S.replace(/\+/g, " ");
    if (f === "iso-8859-1")
      return m.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(m);
    } catch {
      return m;
    }
  }, i = 1024, a = function(t, f, m, A, x) {
    if (t.length === 0)
      return t;
    var q = t;
    if (typeof t == "symbol" ? q = Symbol.prototype.toString.call(t) : typeof t != "string" && (q = String(t)), m === "iso-8859-1")
      return escape(q).replace(/%u[0-9a-f]{4}/gi, function(V) {
        return "%26%23" + parseInt(V.slice(2), 16) + "%3B";
      });
    for (var T = "", N = 0; N < q.length; N += i) {
      for (var G = q.length >= i ? q.slice(N, N + i) : q, D = [], B = 0; B < G.length; ++B) {
        var u = G.charCodeAt(B);
        if (u === 45 || u === 46 || u === 95 || u === 126 || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122 || x === o.RFC1738 && (u === 40 || u === 41)) {
          D[D.length] = G.charAt(B);
          continue;
        }
        if (u < 128) {
          D[D.length] = p[u];
          continue;
        }
        if (u < 2048) {
          D[D.length] = p[192 | u >> 6] + p[128 | u & 63];
          continue;
        }
        if (u < 55296 || u >= 57344) {
          D[D.length] = p[224 | u >> 12] + p[128 | u >> 6 & 63] + p[128 | u & 63];
          continue;
        }
        B += 1, u = 65536 + ((u & 1023) << 10 | G.charCodeAt(B) & 1023), D[D.length] = p[240 | u >> 18] + p[128 | u >> 12 & 63] + p[128 | u >> 6 & 63] + p[128 | u & 63];
      }
      T += D.join("");
    }
    return T;
  }, w = function(t) {
    for (var f = [{ obj: { o: t }, prop: "o" }], m = [], A = 0; A < f.length; ++A)
      for (var x = f[A], q = x.obj[x.prop], T = Object.keys(q), N = 0; N < T.length; ++N) {
        var G = T[N], D = q[G];
        typeof D == "object" && D !== null && m.indexOf(D) === -1 && (f.push({ obj: q, prop: G }), m.push(D));
      }
    return d(f), t;
  }, y = function(t) {
    return Object.prototype.toString.call(t) === "[object RegExp]";
  }, g = function(t) {
    return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
  }, M = function(t, f, m, A) {
    if (I(t)) {
      var x = v(t) + 1;
      return t[x] = f, O(t, x), t;
    }
    var q = [].concat(t, f);
    return q.length > m ? E(h(q, { plainObjects: A }), q.length - 1) : q;
  }, P = function(t, f) {
    if (c(t)) {
      for (var m = [], A = 0; A < t.length; A += 1)
        m.push(f(t[A]));
      return m;
    }
    return f(t);
  };
  return Er = {
    arrayToObject: h,
    assign: b,
    combine: M,
    compact: w,
    decode: n,
    encode: a,
    isBuffer: g,
    isOverflow: I,
    isRegExp: y,
    maybeMap: P,
    merge: F
  }, Er;
}
var Pr, _t;
function In() {
  if (_t) return Pr;
  _t = 1;
  var o = Wt(), l = /* @__PURE__ */ Gt(), s = /* @__PURE__ */ _r(), c = Object.prototype.hasOwnProperty, R = {
    brackets: function(a) {
      return a + "[]";
    },
    comma: "comma",
    indices: function(a, w) {
      return a + "[" + w + "]";
    },
    repeat: function(a) {
      return a;
    }
  }, E = Array.isArray, I = Array.prototype.push, v = function(i, a) {
    I.apply(i, E(a) ? a : [a]);
  }, O = Date.prototype.toISOString, p = s.default, d = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: l.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: p,
    formatter: s.formatters[p],
    // deprecated
    indices: !1,
    serializeDate: function(a) {
      return O.call(a);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, h = function(a) {
    return typeof a == "string" || typeof a == "number" || typeof a == "boolean" || typeof a == "symbol" || typeof a == "bigint";
  }, F = {}, b = function i(a, w, y, g, M, P, S, t, f, m, A, x, q, T, N, G, D, B) {
    for (var u = a, V = B, te = 0, ye = !1; (V = V.get(F)) !== void 0 && !ye; ) {
      var ae = V.get(a);
      if (te += 1, typeof ae < "u") {
        if (ae === te)
          throw new RangeError("Cyclic object value");
        ye = !0;
      }
      typeof V.get(F) > "u" && (te = 0);
    }
    if (typeof m == "function" ? u = m(w, u) : u instanceof Date ? u = q(u) : y === "comma" && E(u) && (u = l.maybeMap(u, function(X) {
      return X instanceof Date ? q(X) : X;
    })), u === null) {
      if (P)
        return f && !G ? f(w, d.encoder, D, "key", T) : w;
      u = "";
    }
    if (h(u) || l.isBuffer(u)) {
      if (f) {
        var oe = G ? w : f(w, d.encoder, D, "key", T);
        return [N(oe) + "=" + N(f(u, d.encoder, D, "value", T))];
      }
      return [N(w) + "=" + N(String(u))];
    }
    var ie = [];
    if (typeof u > "u")
      return ie;
    var ne;
    if (y === "comma" && E(u))
      G && f && (u = l.maybeMap(u, f)), ne = [{ value: u.length > 0 ? u.join(",") || null : void 0 }];
    else if (E(m))
      ne = m;
    else {
      var Y = Object.keys(u);
      ne = A ? Y.sort(A) : Y;
    }
    var fe = t ? String(w).replace(/\./g, "%2E") : String(w), ue = g && E(u) && u.length === 1 ? fe + "[]" : fe;
    if (M && E(u) && u.length === 0)
      return ue + "[]";
    for (var z = 0; z < ne.length; ++z) {
      var $ = ne[z], k = typeof $ == "object" && $ && typeof $.value < "u" ? $.value : u[$];
      if (!(S && k === null)) {
        var L = x && t ? String($).replace(/\./g, "%2E") : String($), H = E(u) ? typeof y == "function" ? y(ue, L) : ue : ue + (x ? "." + L : "[" + L + "]");
        B.set(a, te);
        var K = o();
        K.set(F, B), v(ie, i(
          k,
          H,
          y,
          g,
          M,
          P,
          S,
          t,
          y === "comma" && G && E(u) ? null : f,
          m,
          A,
          x,
          q,
          T,
          N,
          G,
          D,
          K
        ));
      }
    }
    return ie;
  }, n = function(a) {
    if (!a)
      return d;
    if (typeof a.allowEmptyArrays < "u" && typeof a.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof a.encodeDotInKeys < "u" && typeof a.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (a.encoder !== null && typeof a.encoder < "u" && typeof a.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var w = a.charset || d.charset;
    if (typeof a.charset < "u" && a.charset !== "utf-8" && a.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var y = s.default;
    if (typeof a.format < "u") {
      if (!c.call(s.formatters, a.format))
        throw new TypeError("Unknown format option provided.");
      y = a.format;
    }
    var g = s.formatters[y], M = d.filter;
    (typeof a.filter == "function" || E(a.filter)) && (M = a.filter);
    var P;
    if (a.arrayFormat in R ? P = a.arrayFormat : "indices" in a ? P = a.indices ? "indices" : "repeat" : P = d.arrayFormat, "commaRoundTrip" in a && typeof a.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var S = typeof a.allowDots > "u" ? a.encodeDotInKeys === !0 ? !0 : d.allowDots : !!a.allowDots;
    return {
      addQueryPrefix: typeof a.addQueryPrefix == "boolean" ? a.addQueryPrefix : d.addQueryPrefix,
      allowDots: S,
      allowEmptyArrays: typeof a.allowEmptyArrays == "boolean" ? !!a.allowEmptyArrays : d.allowEmptyArrays,
      arrayFormat: P,
      charset: w,
      charsetSentinel: typeof a.charsetSentinel == "boolean" ? a.charsetSentinel : d.charsetSentinel,
      commaRoundTrip: !!a.commaRoundTrip,
      delimiter: typeof a.delimiter > "u" ? d.delimiter : a.delimiter,
      encode: typeof a.encode == "boolean" ? a.encode : d.encode,
      encodeDotInKeys: typeof a.encodeDotInKeys == "boolean" ? a.encodeDotInKeys : d.encodeDotInKeys,
      encoder: typeof a.encoder == "function" ? a.encoder : d.encoder,
      encodeValuesOnly: typeof a.encodeValuesOnly == "boolean" ? a.encodeValuesOnly : d.encodeValuesOnly,
      filter: M,
      format: y,
      formatter: g,
      serializeDate: typeof a.serializeDate == "function" ? a.serializeDate : d.serializeDate,
      skipNulls: typeof a.skipNulls == "boolean" ? a.skipNulls : d.skipNulls,
      sort: typeof a.sort == "function" ? a.sort : null,
      strictNullHandling: typeof a.strictNullHandling == "boolean" ? a.strictNullHandling : d.strictNullHandling
    };
  };
  return Pr = function(i, a) {
    var w = i, y = n(a), g, M;
    typeof y.filter == "function" ? (M = y.filter, w = M("", w)) : E(y.filter) && (M = y.filter, g = M);
    var P = [];
    if (typeof w != "object" || w === null)
      return "";
    var S = R[y.arrayFormat], t = S === "comma" && y.commaRoundTrip;
    g || (g = Object.keys(w)), y.sort && g.sort(y.sort);
    for (var f = o(), m = 0; m < g.length; ++m) {
      var A = g[m], x = w[A];
      y.skipNulls && x === null || v(P, b(
        x,
        A,
        S,
        t,
        y.allowEmptyArrays,
        y.strictNullHandling,
        y.skipNulls,
        y.encodeDotInKeys,
        y.encode ? y.encoder : null,
        y.filter,
        y.sort,
        y.allowDots,
        y.serializeDate,
        y.format,
        y.formatter,
        y.encodeValuesOnly,
        y.charset,
        f
      ));
    }
    var q = P.join(y.delimiter), T = y.addQueryPrefix === !0 ? "?" : "";
    return y.charsetSentinel && (y.charset === "iso-8859-1" ? T += "utf8=%26%2310003%3B&" : T += "utf8=%E2%9C%93&"), q.length > 0 ? T + q : "";
  }, Pr;
}
var Rr, Ft;
function qn() {
  if (Ft) return Rr;
  Ft = 1;
  var o = /* @__PURE__ */ Gt(), l = Object.prototype.hasOwnProperty, s = Array.isArray, c = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: o.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, R = function(b) {
    return b.replace(/&#(\d+);/g, function(n, i) {
      return String.fromCharCode(parseInt(i, 10));
    });
  }, E = function(b, n, i) {
    if (b && typeof b == "string" && n.comma && b.indexOf(",") > -1)
      return b.split(",");
    if (n.throwOnLimitExceeded && i >= n.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + n.arrayLimit + " element" + (n.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return b;
  }, I = "utf8=%26%2310003%3B", v = "utf8=%E2%9C%93", O = function(n, i) {
    var a = { __proto__: null }, w = i.ignoreQueryPrefix ? n.replace(/^\?/, "") : n;
    w = w.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var y = i.parameterLimit === 1 / 0 ? void 0 : i.parameterLimit, g = w.split(
      i.delimiter,
      i.throwOnLimitExceeded ? y + 1 : y
    );
    if (i.throwOnLimitExceeded && g.length > y)
      throw new RangeError("Parameter limit exceeded. Only " + y + " parameter" + (y === 1 ? "" : "s") + " allowed.");
    var M = -1, P, S = i.charset;
    if (i.charsetSentinel)
      for (P = 0; P < g.length; ++P)
        g[P].indexOf("utf8=") === 0 && (g[P] === v ? S = "utf-8" : g[P] === I && (S = "iso-8859-1"), M = P, P = g.length);
    for (P = 0; P < g.length; ++P)
      if (P !== M) {
        var t = g[P], f = t.indexOf("]="), m = f === -1 ? t.indexOf("=") : f + 1, A, x;
        if (m === -1 ? (A = i.decoder(t, c.decoder, S, "key"), x = i.strictNullHandling ? null : "") : (A = i.decoder(t.slice(0, m), c.decoder, S, "key"), A !== null && (x = o.maybeMap(
          E(
            t.slice(m + 1),
            i,
            s(a[A]) ? a[A].length : 0
          ),
          function(T) {
            return i.decoder(T, c.decoder, S, "value");
          }
        ))), x && i.interpretNumericEntities && S === "iso-8859-1" && (x = R(String(x))), t.indexOf("[]=") > -1 && (x = s(x) ? [x] : x), A !== null) {
          var q = l.call(a, A);
          q && i.duplicates === "combine" ? a[A] = o.combine(
            a[A],
            x,
            i.arrayLimit,
            i.plainObjects
          ) : (!q || i.duplicates === "last") && (a[A] = x);
        }
      }
    return a;
  }, p = function(b, n, i, a) {
    var w = 0;
    if (b.length > 0 && b[b.length - 1] === "[]") {
      var y = b.slice(0, -1).join("");
      w = Array.isArray(n) && n[y] ? n[y].length : 0;
    }
    for (var g = a ? n : E(n, i, w), M = b.length - 1; M >= 0; --M) {
      var P, S = b[M];
      if (S === "[]" && i.parseArrays)
        o.isOverflow(g) ? P = g : P = i.allowEmptyArrays && (g === "" || i.strictNullHandling && g === null) ? [] : o.combine(
          [],
          g,
          i.arrayLimit,
          i.plainObjects
        );
      else {
        P = i.plainObjects ? { __proto__: null } : {};
        var t = S.charAt(0) === "[" && S.charAt(S.length - 1) === "]" ? S.slice(1, -1) : S, f = i.decodeDotInKeys ? t.replace(/%2E/g, ".") : t, m = parseInt(f, 10);
        !i.parseArrays && f === "" ? P = { 0: g } : !isNaN(m) && S !== f && String(m) === f && m >= 0 && i.parseArrays && m <= i.arrayLimit ? (P = [], P[m] = g) : f !== "__proto__" && (P[f] = g);
      }
      g = P;
    }
    return g;
  }, d = function(n, i) {
    var a = i.allowDots ? n.replace(/\.([^.[]+)/g, "[$1]") : n;
    if (i.depth <= 0)
      return !i.plainObjects && l.call(Object.prototype, a) && !i.allowPrototypes ? void 0 : [a];
    var w = /(\[[^[\]]*])/, y = /(\[[^[\]]*])/g, g = w.exec(a), M = g ? a.slice(0, g.index) : a, P = [];
    if (M) {
      if (!i.plainObjects && l.call(Object.prototype, M) && !i.allowPrototypes)
        return;
      P.push(M);
    }
    for (var S = 0; (g = y.exec(a)) !== null && S < i.depth; ) {
      S += 1;
      var t = g[1].slice(1, -1);
      if (!i.plainObjects && l.call(Object.prototype, t) && !i.allowPrototypes)
        return;
      P.push(g[1]);
    }
    if (g) {
      if (i.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + i.depth + " and strictDepth is true");
      P.push("[" + a.slice(g.index) + "]");
    }
    return P;
  }, h = function(n, i, a, w) {
    if (n) {
      var y = d(n, a);
      if (y)
        return p(y, i, a, w);
    }
  }, F = function(n) {
    if (!n)
      return c;
    if (typeof n.allowEmptyArrays < "u" && typeof n.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof n.decodeDotInKeys < "u" && typeof n.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (n.decoder !== null && typeof n.decoder < "u" && typeof n.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof n.charset < "u" && n.charset !== "utf-8" && n.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof n.throwOnLimitExceeded < "u" && typeof n.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var i = typeof n.charset > "u" ? c.charset : n.charset, a = typeof n.duplicates > "u" ? c.duplicates : n.duplicates;
    if (a !== "combine" && a !== "first" && a !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var w = typeof n.allowDots > "u" ? n.decodeDotInKeys === !0 ? !0 : c.allowDots : !!n.allowDots;
    return {
      allowDots: w,
      allowEmptyArrays: typeof n.allowEmptyArrays == "boolean" ? !!n.allowEmptyArrays : c.allowEmptyArrays,
      allowPrototypes: typeof n.allowPrototypes == "boolean" ? n.allowPrototypes : c.allowPrototypes,
      allowSparse: typeof n.allowSparse == "boolean" ? n.allowSparse : c.allowSparse,
      arrayLimit: typeof n.arrayLimit == "number" ? n.arrayLimit : c.arrayLimit,
      charset: i,
      charsetSentinel: typeof n.charsetSentinel == "boolean" ? n.charsetSentinel : c.charsetSentinel,
      comma: typeof n.comma == "boolean" ? n.comma : c.comma,
      decodeDotInKeys: typeof n.decodeDotInKeys == "boolean" ? n.decodeDotInKeys : c.decodeDotInKeys,
      decoder: typeof n.decoder == "function" ? n.decoder : c.decoder,
      delimiter: typeof n.delimiter == "string" || o.isRegExp(n.delimiter) ? n.delimiter : c.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof n.depth == "number" || n.depth === !1 ? +n.depth : c.depth,
      duplicates: a,
      ignoreQueryPrefix: n.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof n.interpretNumericEntities == "boolean" ? n.interpretNumericEntities : c.interpretNumericEntities,
      parameterLimit: typeof n.parameterLimit == "number" ? n.parameterLimit : c.parameterLimit,
      parseArrays: n.parseArrays !== !1,
      plainObjects: typeof n.plainObjects == "boolean" ? n.plainObjects : c.plainObjects,
      strictDepth: typeof n.strictDepth == "boolean" ? !!n.strictDepth : c.strictDepth,
      strictNullHandling: typeof n.strictNullHandling == "boolean" ? n.strictNullHandling : c.strictNullHandling,
      throwOnLimitExceeded: typeof n.throwOnLimitExceeded == "boolean" ? n.throwOnLimitExceeded : !1
    };
  };
  return Rr = function(b, n) {
    var i = F(n);
    if (b === "" || b === null || typeof b > "u")
      return i.plainObjects ? { __proto__: null } : {};
    for (var a = typeof b == "string" ? O(b, i) : b, w = i.plainObjects ? { __proto__: null } : {}, y = Object.keys(a), g = 0; g < y.length; ++g) {
      var M = y[g], P = h(M, a[M], i, typeof b == "string");
      w = o.merge(w, P, i);
    }
    return i.allowSparse === !0 ? w : o.compact(w);
  }, Rr;
}
var xr, Dt;
function _n() {
  if (Dt) return xr;
  Dt = 1;
  var o = /* @__PURE__ */ In(), l = /* @__PURE__ */ qn(), s = /* @__PURE__ */ _r();
  return xr = {
    formats: s,
    parse: l,
    stringify: o
  }, xr;
}
var Fn = /* @__PURE__ */ _n();
const Mn = /* @__PURE__ */ Yt(Fn);
export {
  Mn as q
};
